import { Services } from '@estercare/ester-shared'

export const isServiceIdentifier = (identifier: unknown): identifier is Services => {
  return typeof identifier === 'string' && Object.values(Services).includes(identifier as Services)
}

export const isCertificationService = (serviceIdentifier: unknown): boolean => serviceIdentifier === 'CERTIFICATION'
